import React, { useState, useEffect } from "react";
import { Button, TextField } from "@mui/material";
import * as sweetalert from "sweetalert";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useFormupdate } from "./useFormupdate";
import { Grid } from "@material-ui/core";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function Lirtnapercentage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    price_form_special_distributor_to_general: "",
    price_form_special_distributor_to_special: "",
    price_form_special_distributor_to_client: "",
    price_form_general_distributor_to_special: "",
    price_form_general_distributor_to_general: "",
    price_form_general_distributor_to_client: "",
    price_form_client_to_client: "",
    price_form_client_to_special_distributor: "",
    price_form_client_to_general_distributor: "",
    profit_form_special_distributor_to_general: "",
    profit_form_special_distributor_to_special: "",
    profit_form_special_distributor_to_client: "",
    profit_form_general_distributor_to_special: "",
    profit_form_general_distributor_to_general: "",
    profit_form_general_distributor_to_client: "",
    profit_form_client_to_client: "",
    profit_form_client_to_special_distributor: "",
    profit_form_client_to_general_distributor: "",
    price_for_client_e_payment: "",
    price_for_general_distributor_e_payment: "",
    price_for_special_distributor_e_payment: "",
  });
  const initialFValues = {
    price_form_special_distributor_to_general: "",
    price_form_special_distributor_to_special: "",
    price_form_special_distributor_to_client: "",
    price_form_general_distributor_to_special: "",
    price_form_general_distributor_to_general: "",
    price_form_general_distributor_to_client: "",
    price_form_client_to_client: "",
    price_form_client_to_special_distributor: "",
    price_form_client_to_general_distributor: "",
    profit_form_special_distributor_to_general: "",
    profit_form_special_distributor_to_special: "",
    profit_form_special_distributor_to_client: "",
    profit_form_general_distributor_to_special: "",
    profit_form_general_distributor_to_general: "",
    profit_form_general_distributor_to_client: "",
    profit_form_client_to_special_distributor: "",
    profit_form_client_to_client: "",
    profit_form_client_to_general_distributor: "",
    price_for_client_e_payment: "",
    price_for_general_distributor_e_payment: "",
    price_for_special_distributor_e_payment: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("price_for_general_distributor" in fieldValues) {
      if (fieldValues.price_for_general_distributor > 1) {
        temp.price_for_general_distributor = "يحب أن تكون القيمة بين 0 و 1";
      } else {
        temp.price_for_general_distributor = "";
      }
    }

    if ("price_for_special_distributor" in fieldValues) {
      if (fieldValues.price_for_special_distributor > 1) {
        temp.price_for_special_distributor = "يحب أن تكون القيمة بين 0 و 1";
      } else {
        temp.price_for_special_distributor = "";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const { loginInput, errors, setErrors } = useFormupdate(
    initialFValues,
    true,
    validate
  );

  const handleChange = (e) => {
    e.persist();

    if (e.target.value < 1 && e.target.value >= 0) {
      setFormValues({ ...formValues, [e.target.name]: e.target.value });
    } else {
      sweetalert("يجب أن يكون الر قم بين الصفر و الواحد ");
    }
  };

  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/getpriceByID/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setFormValues({
          ...formValues,
          price_form_special_distributor_to_general:
            res.data.data.fundprices[0]
              .price_form_special_distributor_to_general,

          price_form_special_distributor_to_special:
            res.data.data.fundprices[0]
              .price_form_special_distributor_to_special,

          price_form_special_distributor_to_client:
            res.data.data.fundprices[0]
              .price_form_special_distributor_to_client,

          price_form_general_distributor_to_special:
            res.data.data.fundprices[0]
              .price_form_general_distributor_to_special,

          price_form_general_distributor_to_general:
            res.data.data.fundprices[0]
              .price_form_general_distributor_to_general,

          price_form_general_distributor_to_client:
            res.data.data.fundprices[0]
              .price_form_general_distributor_to_client,

          price_form_client_to_client:
            res.data.data.fundprices[0].price_form_client_to_client,

          price_form_client_to_special_distributor:
            res.data.data.fundprices[0]
              .price_form_client_to_special_distributor,

          price_form_client_to_general_distributor:
            res.data.data.fundprices[0]
              .price_form_client_to_general_distributor,

          profit_form_special_distributor_to_general:
            res.data.data.fundprices[0]
              .profit_form_special_distributor_to_general,

          profit_form_special_distributor_to_special:
            res.data.data.fundprices[0]
              .profit_form_special_distributor_to_special,

          profit_form_special_distributor_to_client:
            res.data.data.fundprices[0]
              .profit_form_special_distributor_to_client,

          profit_form_general_distributor_to_special:
            res.data.data.fundprices[0]
              .profit_form_general_distributor_to_special,

          profit_form_general_distributor_to_general:
            res.data.data.fundprices[0]
              .profit_form_general_distributor_to_general,

          profit_form_general_distributor_to_client:
            res.data.data.fundprices[0]
              .profit_form_general_distributor_to_client,

          profit_form_client_to_client:
            res.data.data.fundprices[0].profit_form_client_to_client,

          profit_form_client_to_special_distributor:
            res.data.data.fundprices[0]
              .profit_form_client_to_special_distributor,

          profit_form_client_to_general_distributor:
            res.data.data.fundprices[0]
              .profit_form_client_to_general_distributor,

          price_for_client_e_payment:
            res.data.data.fundprices[0].price_for_client_e_payment,

          price_for_general_distributor_e_payment:
            res.data.data.fundprices[0].price_for_general_distributor_e_payment,

          price_for_special_distributor_e_payment:
            res.data.data.fundprices[0].price_for_special_distributor_e_payment,
        });
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      price_form_special_distributor_to_general:
        formValues.price_form_special_distributor_to_general,
      price_form_special_distributor_to_special:
        formValues.price_form_special_distributor_to_special,
      price_form_special_distributor_to_client:
        formValues.price_form_special_distributor_to_client,
      price_form_general_distributor_to_special:
        formValues.price_form_general_distributor_to_special,
      price_form_general_distributor_to_general:
        formValues.price_form_general_distributor_to_general,
      price_form_general_distributor_to_client:
        formValues.price_form_general_distributor_to_client,
      price_form_client_to_client: formValues.price_form_client_to_client,
      price_form_client_to_special_distributor:
        formValues.price_form_client_to_special_distributor,
      price_form_client_to_general_distributor:
        formValues.price_form_client_to_general_distributor,
      profit_for_client: formValues.profit_for_client,
      profit_form_special_distributor_to_general:
        formValues.profit_form_special_distributor_to_general,
      profit_form_special_distributor_to_special:
        formValues.profit_form_special_distributor_to_special,
      profit_form_special_distributor_to_client:
        formValues.profit_form_special_distributor_to_client,
      profit_form_general_distributor_to_special:
        formValues.profit_form_general_distributor_to_special,
      profit_form_general_distributor_to_general:
        formValues.profit_form_general_distributor_to_general,
      profit_form_general_distributor_to_client:
        formValues.profit_form_general_distributor_to_client,
      profit_form_client_to_client: formValues.profit_form_client_to_client,
      profit_form_client_to_special_distributor:
        formValues.profit_form_client_to_special_distributor,
      profit_form_client_to_general_distributor:
        formValues.profit_form_client_to_general_distributor,
      price_for_client_e_payment: formValues.price_for_client_e_payment,
      price_for_general_distributor_e_payment:
        formValues.price_for_general_distributor_e_payment,
      price_for_special_distributor_e_payment:
        formValues.price_for_special_distributor_e_payment,
    };

    axios
      .post(
        `${BaseUrl}/api/addpriceTofund/${id}`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.status === true) {
          sweetalert("تم التعديل بنجاح", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
          navigate("/getfund");
        } else {
          sweetalert("خطأ في عملية التعديل", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
          setFormValues({ ...formValues, error_list: res.data.error });
        }
      });
  };

  return (
    <div className="main-div">
      <h3 className="titlepage">تعديل نسبة</h3>

      <form
        className="form-group"
        method="post"
        enctype="multipart/form-data"
        noValidate
        onSubmit={handleSubmit}
      >
        <div className="form-group">
          <Grid container maxWidth="sm" spacing={4}>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder=" السعر من الموزع الخاص إلى العام"
                className="form-control"
                label="السعر من الموزع الخاص إلى العام"
                name="price_form_special_distributor_to_general"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.price_form_special_distributor_to_general}
                onChange={handleChange}
                error={
                  formValues.price_form_special_distributor_to_general.error
                }
                helperText={
                  formValues.price_form_special_distributor_to_general.error &&
                  formValues.price_form_special_distributor_to_general
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="السعر من الموزع الخاص إلى الخاص"
                className="form-control"
                label="السعر من الموزع الخاص إلى الخاص"
                name="price_form_special_distributor_to_special"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                fullWidth
                type="text"
                value={formValues.price_form_special_distributor_to_special}
                onChange={handleChange}
                error={
                  formValues.price_form_special_distributor_to_special.error
                }
                helperText={
                  formValues.price_form_special_distributor_to_special.error &&
                  formValues.price_form_special_distributor_to_special
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="السعر من الموزع الخاص إلى الزبون"
                className="form-control"
                label="السعر من الموزع الخاص إلى الزبون"
                name="price_form_special_distributor_to_client"
                fullWidth
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                type="text"
                value={formValues.price_form_special_distributor_to_client}
                onChange={handleChange}
                error={
                  formValues.price_form_special_distributor_to_client.error
                }
                helperText={
                  formValues.price_form_special_distributor_to_client.error &&
                  formValues.price_form_special_distributor_to_client
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="السعر من الموزع العام إلى الخاص"
                className="form-control"
                label="السعر من الموزع العام إلى الخاص"
                name="price_form_general_distributor_to_special"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.price_form_general_distributor_to_special}
                onChange={handleChange}
                error={
                  formValues.price_form_general_distributor_to_special.error
                }
                helperText={
                  formValues.price_form_general_distributor_to_special.error &&
                  formValues.price_form_general_distributor_to_special
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="السعر من موزع العام إلى العام"
                className="form-control"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                label="السعر من موزع العام إلى العام"
                name="price_form_general_distributor_to_general"
                fullWidth
                type="text"
                value={formValues.price_form_general_distributor_to_general}
                onChange={handleChange}
                error={
                  formValues.price_form_general_distributor_to_general.error
                }
                helperText={
                  formValues.price_form_general_distributor_to_general.error &&
                  formValues.price_form_general_distributor_to_general
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="السعر من موزع عام إلى العميل"
                className="form-control"
                label="السعر من موزع عام إلى العميل"
                name="price_form_general_distributor_to_client"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.price_form_general_distributor_to_client}
                onChange={handleChange}
                error={
                  formValues.price_form_general_distributor_to_client.error
                }
                helperText={
                  formValues.price_form_general_distributor_to_client.error &&
                  formValues.price_form_general_distributor_to_client
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="السعر من الزبون للزبون"
                className="form-control"
                label="السعر من الزبون للزبون"
                name="price_form_client_to_client"
                fullWidth
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                type="text"
                value={formValues.price_form_client_to_client}
                onChange={handleChange}
                error={formValues.price_form_client_to_client.error}
                helperText={
                  formValues.price_form_client_to_client.error &&
                  formValues.price_form_client_to_client.errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="السعر من الزبون للموزع الخاص"
                className="form-control"
                label="السعر من الزبون للموزع الخاص"
                name="price_form_client_to_special_distributor"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.price_form_client_to_special_distributor}
                onChange={handleChange}
                error={
                  formValues.price_form_client_to_special_distributor.error
                }
                helperText={
                  formValues.price_form_client_to_special_distributor.error &&
                  formValues.price_form_client_to_special_distributor
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="السعر من الزبون للموزع العام"
                className="form-control"
                label="السعر من الزبون للموزع العام"
                name="price_form_client_to_general_distributor"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.price_form_client_to_general_distributor}
                onChange={handleChange}
                error={
                  formValues.price_form_client_to_general_distributor.error
                }
                helperText={
                  formValues.price_form_client_to_general_distributor.error &&
                  formValues.price_form_client_to_general_distributor
                    .errorMessage
                }
              />
            </Grid>

            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح  من الموزع الخاص للعام"
                className="form-control"
                label="ربح من الموزع الخاص للعام"
                name="profit_form_special_distributor_to_general"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_form_special_distributor_to_general}
                onChange={handleChange}
                error={
                  formValues.profit_form_special_distributor_to_general.error
                }
                helperText={
                  formValues.profit_form_special_distributor_to_general.error &&
                  formValues.profit_form_special_distributor_to_general
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح  من الموزع الخاص للخاص"
                className="form-control"
                label="ربح من الموزع الخاص للخاص"
                name="profit_form_special_distributor_to_special"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_form_special_distributor_to_special}
                onChange={handleChange}
                error={
                  formValues.profit_form_special_distributor_to_special.error
                }
                helperText={
                  formValues.profit_form_special_distributor_to_special.error &&
                  formValues.profit_form_special_distributor_to_special
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح  من الموزع الخاص للزبون"
                className="form-control"
                label="ربح من الموزع الخاص للزبون"
                name="profit_form_special_distributor_to_client"
                fullWidth
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                type="text"
                value={formValues.profit_form_special_distributor_to_client}
                onChange={handleChange}
                error={
                  formValues.profit_form_special_distributor_to_client.error
                }
                helperText={
                  formValues.profit_form_special_distributor_to_client.error &&
                  formValues.profit_form_special_distributor_to_client
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح  من الموزع العام للخاص"
                className="form-control"
                label="ربح من الموزع العام للخاص"
                name="profit_form_general_distributor_to_special"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_form_general_distributor_to_special}
                onChange={handleChange}
                error={
                  formValues.profit_form_general_distributor_to_special.error
                }
                helperText={
                  formValues.profit_form_general_distributor_to_special.error &&
                  formValues.profit_form_general_distributor_to_special
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح  من الموزع العام للعام"
                className="form-control"
                label="ربح من الموزع العام للعام"
                name="profit_form_general_distributor_to_general"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_form_general_distributor_to_general}
                onChange={handleChange}
                error={
                  formValues.profit_form_general_distributor_to_general.error
                }
                helperText={
                  formValues.profit_form_general_distributor_to_general.error &&
                  formValues.profit_form_general_distributor_to_general
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح  من الموزع العام للزبون"
                className="form-control"
                label="ربح من الموزع العام للزبون"
                name="profit_form_general_distributor_to_client"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_form_general_distributor_to_client}
                onChange={handleChange}
                error={
                  formValues.profit_form_general_distributor_to_client.error
                }
                helperText={
                  formValues.profit_form_general_distributor_to_client.error &&
                  formValues.profit_form_general_distributor_to_client
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح  من  الزبون للزبون"
                className="form-control"
                label="ربح من الزبون  للزبون"
                name="profit_form_client_to_client"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_form_client_to_client}
                onChange={handleChange}
                error={formValues.profit_form_client_to_client.error}
                helperText={
                  formValues.profit_form_client_to_client.error &&
                  formValues.profit_form_client_to_client.errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح  من  الزبون للموزع الخاص"
                className="form-control"
                label="ربح من الزبون  للموزع الخاص"
                name="profit_form_client_to_special_distributor"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_form_client_to_special_distributor}
                onChange={handleChange}
                error={
                  formValues.profit_form_client_to_special_distributor.error
                }
                helperText={
                  formValues.profit_form_client_to_special_distributor.error &&
                  formValues.profit_form_client_to_special_distributor
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح  من  الزبون للموزع العام"
                className="form-control"
                label="ربح من الزبون  للموزع العام"
                name="profit_form_client_to_general_distributor"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_form_client_to_general_distributor}
                onChange={handleChange}
                error={
                  formValues.profit_form_client_to_general_distributor.error
                }
                helperText={
                  formValues.profit_form_client_to_general_distributor.error &&
                  formValues.profit_form_client_to_general_distributor
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="price_for_client_e_payment"
                className="form-control"
                label="price_for_client_e_payment"
                name="price_for_client_e_payment"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.price_for_client_e_payment}
                onChange={handleChange}
                error={formValues.price_for_client_e_payment.error}
                helperText={
                  formValues.price_for_client_e_payment.error &&
                  formValues.price_for_client_e_payment.errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="price_for_general_distributor_e_payment"
                className="form-control"
                label="price_for_general_distributor_e_payment"
                name="price_for_general_distributor_e_payment"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.price_for_general_distributor_e_payment}
                onChange={handleChange}
                error={formValues.price_for_general_distributor_e_payment.error}
                helperText={
                  formValues.price_for_general_distributor_e_payment.error &&
                  formValues.price_for_general_distributor_e_payment
                    .errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="price_for_special_distributor_e_payment"
                className="form-control"
                label="price_for_special_distributor_e_payment"
                name="price_for_special_distributor_e_payment"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.price_for_special_distributor_e_payment}
                onChange={handleChange}
                error={formValues.price_for_special_distributor_e_payment.error}
                helperText={
                  formValues.price_for_special_distributor_e_payment.error &&
                  formValues.price_for_special_distributor_e_payment
                    .errorMessage
                }
              />
            </Grid>
          </Grid>
        </div>
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          <Button
            type="submit"
            variant="contained"
            className="btn-submit"
            color="secondary"
          >
            حفظ
          </Button>
        </Grid>
      </form>
    </div>
  );
}
